module.exports = __webpack_public_path__ + "img/xw-001.b3a5e5e4.jpg";